/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AssetsMelcoModelsError,
    AssetsMelcoModelsErrorFromJSON,
    AssetsMelcoModelsErrorToJSON,
    AssetsMelcoModelsGenericList1MelcoAssetsModelsAlphabetAssetListItem,
    AssetsMelcoModelsGenericList1MelcoAssetsModelsAlphabetAssetListItemFromJSON,
    AssetsMelcoModelsGenericList1MelcoAssetsModelsAlphabetAssetListItemToJSON,
} from '../models';

export interface AssetAlphabetsApiAssetAlphabetsSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    isMonogram?: boolean;
    categoryList?: string;
    productList?: string;
}

/**
 * 
 */
export class AssetAlphabetsApi extends runtime.BaseAPI {

    /**
     */
    async assetAlphabetsSearchRaw(requestParameters: AssetAlphabetsApiAssetAlphabetsSearchRequest): Promise<runtime.ApiResponse<AssetsMelcoModelsGenericList1MelcoAssetsModelsAlphabetAssetListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.isMonogram !== undefined) {
            queryParameters['is_monogram'] = requestParameters.isMonogram;
        }

        if (requestParameters.categoryList !== undefined) {
            queryParameters['category_list'] = requestParameters.categoryList;
        }

        if (requestParameters.productList !== undefined) {
            queryParameters['product_list'] = requestParameters.productList;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/assets/alphabets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetsMelcoModelsGenericList1MelcoAssetsModelsAlphabetAssetListItemFromJSON(jsonValue));
    }

    /**
     */
    async assetAlphabetsSearch(requestParameters: AssetAlphabetsApiAssetAlphabetsSearchRequest): Promise<AssetsMelcoModelsGenericList1MelcoAssetsModelsAlphabetAssetListItem> {
        const response = await this.assetAlphabetsSearchRaw(requestParameters);
        return await response.value();
    }

}
